import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div
      className="flex min-h-[70vh] flex-col items-center justify-center px-6 text-center"
      data-testid="not-found-page"
    >
      <Compass className="h-12 w-12 text-orange-500" />
      <h1 className="mt-6 text-4xl font-semibold text-slate-900 sm:text-5xl">Voted out</h1>
      <p className="mt-3 max-w-md text-base text-slate-600">
        This page isn't on the island. The link may be out of date or mistyped.
      </p>
      <Link
        to="/home"
        data-testid="not-found-home-link"
        className="mt-8 rounded-full bg-orange-500 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-orange-600"
      >
        Back to camp
      </Link>
    </div>
  );
}
